import i18next from '../i18n';

export type Font = {
  name: string;
  regular: string;
  italic: string | null | boolean;
  bold: string | null | boolean;
  boldItalic?: string;
  ascentOverride?: string;
  descentOverride?: string;
};

export const modernFonts: Font[] = [
  {
    name: 'Cabin',
    regular: '/fonts/customization/Cabin_Condensed-Regular.ttf',
    italic: '/fonts/customization/Cabin_Condensed-Italic.ttf',
    bold: '/fonts/customization/Cabin-Bold.ttf',
  },
  {
    name: 'Barokah Signature',
    regular: '/fonts/customization/Barokah-Signature-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Flyover',
    regular: '/fonts/customization/Flyover.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Novella',
    regular: '/fonts/customization/Novella-Regular.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Sue Ellen Francisco',
    regular: '/fonts/customization/SueEllenFrancisco-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Salmela',
    regular: '/fonts/customization/Salmela.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Amanda',
    regular: '/fonts/customization/Amanda.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Brittany Signature',
    regular: '/fonts/customization/BrittanySignature.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Paper Notes',
    regular: '/fonts/customization/Paper Notes Regular.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'HuntingStar',
    regular: '/fonts/customization/HuntingStar.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Amatic SC',
    regular: '/fonts/customization/AmaticSC-Regular.ttf',
    italic: null,
    bold: '/fonts/customization/AmaticSC-Bold.ttf',
  },
  {
    name: 'Loftygoals',
    regular: '/fonts/customization/Loftygoals-Regular.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Dancing Script',
    regular: '/fonts/customization/DancingScript.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Water Lemon',
    regular: '/fonts/customization/Water Lemon.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'High Empathy',
    regular: '/fonts/customization/HighEmpathy.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Rumpi',
    regular: '/fonts/customization/Rumpi.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Sundiary',
    regular: '/fonts/customization/SundiaryDemo.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'SenjaSantuy',
    regular: '/fonts/customization/SenjaSantuy.otf',
    italic: null,
    bold: null,
  },
  {
    name: 'Monsieur La Doulaise',
    regular: '/fonts/customization/MonsieurLaDoulaise-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Ballet',
    regular: '/fonts/customization/Ballet-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Josefin Sans',
    regular: '/fonts/customization/JosefinSans-Regular.ttf',
    italic: '/fonts/customization/JosefinSans-Italic.ttf',
    bold: '/fonts/customization/JosefinSans-SemiBold.ttf',
  },
  {
    name: 'Josefin Sans Fine',
    regular: '/fonts/customization/JosefinSans-ExtraLight.ttf',
    italic: '/fonts/customization/JosefinSans-ExtraLightItalic.ttf',
    bold: '/fonts/customization/JosefinSans-Light.ttf',
  },
  {
    name: 'Questrial',
    regular: '/fonts/customization/Questrial-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Quicksand',
    regular: '/fonts/customization/Quicksand-Regular.ttf',
    italic: null,
    bold: '/fonts/customization/Quicksand-SemiBold.ttf',
  },
  {
    name: 'Oswald',
    regular: '/fonts/customization/Oswald-Light.ttf',
    italic: null,
    bold: '/fonts/customization/Oswald-Medium.ttf',
  },
  {
    name: 'Poppins',
    regular: '/fonts/customization/Poppins-Regular.ttf',
    italic: '/fonts/customization/Poppins-Italic.ttf',
    bold: '/fonts/customization/Poppins-SemiBold.ttf',
  },
  {
    name: 'Poppins extra',
    regular: '/fonts/customization/Poppins-ExtraBold.ttf',
    italic: '/fonts/customization/Poppins-ExtraBoldItalic.ttf',
    bold: '/fonts/customization/Poppins-Black.ttf',
  },
  {
    name: 'Sansita',
    regular: '/fonts/customization/Sansita-Regular.ttf',
    italic: '/fonts/customization/Sansita-Italic.ttf',
    bold: '/fonts/customization/Sansita-Bold.ttf',
  },
  {
    name: 'Sen',
    regular: '/fonts/customization/Sen-Regular.ttf',
    italic: null,
    bold: '/fonts/customization/Sen-Bold.ttf',
  },
];

export const classicFonts: Font[] = [
  {
    name: 'Abril Fatface',
    regular: '/fonts/customization/AbrilFatface-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Brawler',
    regular: '/fonts/customization/Brawler-Regular.ttf',
    italic: null,
    bold: '/fonts/customization/Brawler-Bold.ttf',
  },
  {
    name: 'Calistoga',
    regular: '/fonts/customization/Calistoga-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'EB Garamond',
    regular: '/fonts/customization/EBGaramond-VariableFont_wght.ttf',
    italic: '/fonts/customization/EBGaramond-Italic-VariableFont_wght.ttf',
    bold: null,
  },
  {
    name: 'Libre Baskerville',
    regular: '/fonts/customization/LibreBaskerville-Regular.ttf',
    italic: '/fonts/customization/LibreBaskerville-Italic.ttf',
    bold: '/fonts/customization/LibreBaskerville-Bold.ttf',
  },
  {
    name: 'PlayfairDisplay',
    regular: '/fonts/customization/PlayfairDisplay-Regular.ttf',
    italic: '/fonts/customization/PlayfairDisplay-Italic.ttf',
    bold: '/fonts/customization/PlayfairDisplay-SemiBold.ttf',
  },
  {
    name: 'Playfair extra',
    regular: '/fonts/customization/PlayfairDisplay-Bold.ttf',
    italic: '/fonts/customization/PlayfairDisplay-BoldItalic.ttf',
    bold: '/fonts/customization/PlayfairDisplay-Black.ttf',
    boldItalic: '/fonts/customization/PlayfairDisplay-BlackItalic.ttf',
  },
  {
    name: 'Yeseva One',
    regular: '/fonts/customization/YesevaOne-Regular.ttf',
    italic: null,
    bold: null,
  },
];

export const calligraphicFonts: Font[] = [
  {
    name: 'Alex Brush',
    regular: '/fonts/customization/AlexBrush-Regular.ttf',
    italic: null,
    bold: false,
  },
  {
    name: 'Ashley Southine',
    regular: '/fonts/customization/Ashley Southine.otf',
    italic: false,
    bold: false,
  },
  {
    name: 'Beloved Journey',
    regular: '/fonts/customization/Beloved Journey.ttf',
    italic: false,
    bold: false,
  },
  {
    name: 'The Wedding Signature',
    regular: '/fonts/customization/The Wedding Signature Regular.otf',
    italic: false,
    bold: false,
  },
  {
    name: 'Cookie',
    regular: '/fonts/customization/Cookie-Regular.ttf',
    italic: false,
    bold: null,
  },
  {
    name: 'Mea Culpa',
    regular: '/fonts/customization/MeaCulpa-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Memory of 2018',
    regular: '/fonts/customization/Memory of 2018.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'MonteCarlo',
    regular: '/fonts/customization/MonteCarlo-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Mrs Saint Delafield',
    regular: '/fonts/customization/MrsSaintDelafield-Regular.ttf',
    italic: false,
    bold: false,
  },
  {
    name: 'Ms Madi',
    regular: '/fonts/customization/MsMadi-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Parisienne',
    regular: '/fonts/customization/Parisienne-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Pinyon Script',
    regular: '/fonts/customization/PinyonScript-Regular.ttf',
    italic: false,
    bold: null,
  },
  {
    name: 'Rouge Script',
    regular: '/fonts/customization/RougeScript-Regular.ttf',
    italic: null,
    bold: false,
  },
  {
    name: 'WindSong',
    regular: '/fonts/customization/WindSong-Regular.ttf',
    italic: false,
    bold: '/fonts/customization/WindSong-Medium.ttf',
  },
];

const handwrittenFonts: Font[] = [
  {
    name: 'Lilac And Linen',
    regular: '/fonts/customization/Lilac And Linen.otf',
    italic: null,
    bold: null,
    ascentOverride: '150%',
    descentOverride: '50%',
  },
  {
    name: 'Borel',
    regular: '/fonts/customization/Borel-Regular.ttf',
    italic: null,
    bold: null,
    ascentOverride: '150%',
    descentOverride: '50%',
  },
  {
    name: 'Daniel',
    regular: '/fonts/customization/daniel.ttf',
    italic: null,
    bold: '/fonts/customization/danielbd.ttf',
    ascentOverride: '140%',
    descentOverride: '60%',
  },
  {
    name: 'Mathilde',
    regular: '/fonts/customization/mathilde.otf',
    italic: false,
    bold: false,
  },
  {
    name: 'Oooh Baby',
    regular: '/fonts/customization/OoohBaby-Regular.ttf',
    italic: false,
    bold: false,
  },
  {
    name: 'Patrick Hand',
    regular: '/fonts/customization/PatrickHand-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Sacramento',
    regular: '/fonts/customization/Sacramento-Regular.ttf',
    italic: false,
    bold: false,
  },
];

export const fantasyFonts: Font[] = [
  {
    name: 'Advent Pro',
    regular: '/fonts/customization/AdventPro-Regular.ttf',
    italic: '/fonts/customization/AdventPro-Italic.ttf',
    bold: '/fonts/customization/AdventPro-Bold.ttf',
  },
  {
    name: 'Cabin Sketch',
    regular: '/fonts/customization/CabinSketch-Regular.ttf',
    italic: null,
    bold: '/fonts/customization/CabinSketch-Bold.ttf',
  },
  {
    name: 'Chewy',
    regular: '/fonts/customization/Chewy-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Fredericka The Great',
    regular: '/fonts/customization/FrederickatheGreat-Regular.ttf',
    italic: null,
    bold: false,
  },
  {
    name: 'Limelight',
    regular: '/fonts/customization/Limelight-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Lobster',
    regular: '/fonts/customization/Lobster-Regular.ttf',
    italic: false,
    bold: false,
  },
  {
    name: 'Noto Color Emoji',
    regular: '/fonts/customization/NotoColorEmoji-Regular.ttf',
    italic: false,
    bold: false,
  },
  {
    name: 'Rampart One',
    regular: '/fonts/customization/RampartOne-Regular.ttf',
    italic: null,
    bold: false,
  },
  {
    name: 'Grandstander',
    regular: '/fonts/customization/Grandstander-Regular.ttf',
    italic: '/fonts/customization/Grandstander-Italic.ttf',
    bold: '/fonts/customization/Grandstander-Bold.ttf',
  },
  {
    name: 'DM Mono',
    regular: '/fonts/customization/DMMono-Regular.ttf',
    italic: '/fonts/customization/DMMono-Italic.ttf',
    bold: '/fonts/customization/DMMono-Medium.ttf',
  },
  {
    name: 'Special elite',
    regular: '/fonts/customization/SpecialElite-Regular.ttf',
    italic: null,
    bold: null,
  },
  {
    name: 'Amiri',
    regular: '/fonts/customization/Amiri-Regular.ttf',
    italic: null,
    bold: null,
  },
];

export const availableFonts: Font[] = [
  ...modernFonts,
  ...classicFonts,
  ...calligraphicFonts,
  ...handwrittenFonts,
  ...fantasyFonts,
];

export const fontsOptions = [
  { value: "'Ashley Southine'", label: "Ashley Southine" },
  { value: "'Amanda'", label: "Amanda" },
  { value: "'Brittany Signature'", label: "Brittany Signature" },
  { value: "'Lilac And Linen'", label: "Lilac And Linen" },
  { value: "'Josefin Sans'", label: "Josefin Sans" },
  { value: "'The Wedding Signature'", label: "The Wedding Signature" },
  { value: "'EB Garamond'", label: "EB Garamond" },
  { value: "'Flyover'", label: "Flyover" },
  { value: "'Novella'", label: "Novella" },
  { value: "'Brawler'", label: "Brawler" },
  { value: "'Sue Ellen Francisco'", label: "Sue Ellen Francisco" },
  { value: "'Questrial'", label: "Questrial" },
  { value: "'Quicksand'", label: "Quicksand" },
  { value: "'Amatic SC'", label: "Amatic SC" },
  { value: "'Borel'", label: "Borel" },
  { value: "'HuntingStar'", label: "HuntingStar" },
  { value: "'Libre Baskerville'", label: "Libre Baskerville" },
  { value: "'Loftygoals'", label: "Loftygoals" },
  { value: "'Dancing Script'", label: "Dancing Script" },
  { value: "'Mea Culpa'", label: "Mea Culpa" },
  { value: "'Memory of 2018'", label: "Memory of 2018" },
  { value: "'PlayfairDisplay'", label: "PlayfairDisplay" },
  { value: "'MonteCarlo'", label: "MonteCarlo" },
  { value: "'Water Lemon'", label: "Water Lemon" },
  { value: "'High Empathy'", label: "High Empathy" },
  { value: "'Poppins'", label: "Poppins" },
  { value: "'Rumpi'", label: "Rumpi" },
  { value: "'Mrs Saint Delafield'", label: "Mrs Saint Delafield" },
  { value: "'Ms Madi'", label: "Ms Madi" },
  { value: "'Oooh Baby'", label: "Oooh Baby" },
  { value: "'Paper Notes'", label: "Paper Notes" },
  { value: "'Parisienne'", label: "Parisienne" },
  { value: "'Pinyon Script'", label: "Pinyon Script" },
  { value: "'Rouge Script'", label: "Rouge Script" },
  { value: "'SenjaSantuy'", label: "SenjaSantuy" },
  { value: "'Sacramento'", label: "Sacramento" },
  { value: "'Monsieur La Doulaise'", label: "Monsieur La Doulaise" },
  { value: "'WindSong'", label: "WindSong" },
  { value: "'Ballet'", label: "Ballet" },
  { value: "'Calistoga'", label: "Calistoga" },
  { value: "'Mathilde'", label: "Mathilde" },
  { value: "'Limelight'", label: "Limelight" },
  { value: "'Lobster'", label: "Lobster" },
  { value: "'Oswald'", label: "Oswald" },
  { value: "'Cabin'", label: "Cabin" },
  { value: "'Grandstander'", label: "Grandstander" },
  { value: "'DM MONO'", label: "DM MONO" },
  { value: "'Patrick Hand'", label: "Patrick Hand" },
  { value: "'Cabin Sketch'", label: "Cabin Sketch" },
  { value: "'Fredericka The Great'", label: "Fredericka The Great" },
  { value: "'Chewy'", label: "Chewy" },
  { value: "'Rampart One'", label: "Rampart One" },
  { value: "'Daniel'", label: "Daniel" },
  { value: "'Sansita'", label: "Sansita" },
  { value: "'Sen'", label: "Sen" },
  { value: "'Special Elite'", label: "Special Elite" },
  { value: "'Yeseva One'", label: "Yeseva One" },
  { value: "'Abril Fatface'", label: "Abril Fatface" },
  { value: "'Advent Pro'", label: "Advent Pro" },
  { value: "'Cookie'", label: "Cookie" },
  { value: "'Daniel'", label: "Daniel" },
  { value: "'Noto'", label: "Noto" },
  { value: "'Barokah Signature'", label: "Barokah Signature" },
  { value: "'Amiri'", label: "Amiri" },

];




// const rawFontsOptions = [
//   { value: "'Ashley Southine'", name: "Ashley Southine", previewSize: 16 },
//   { value: "'Barokah Signature'", name: "Barokah Signature", previewSize: 1 },
//   { value: "'Poppins'", name: "Poppins", previewSize: 14 },
//   { value: "'Josefin Sans'", name: "Josefin Sans", previewSize: 14 },
// ];

// export const fontsOptions = rawFontsOptions.map(f => ({
//   value: f.value,
//   label: React.createElement(
//     "span",
//     { style: { fontFamily: f.value, fontSize: `${f.previewSize}px` } },
//     f.name
//   )
// }));

export const fontsGroups = [
  {
    label: i18next.t('text.modern', { ns: ['common'] }),
    options: modernFonts.map((font) => ({
      value: `'${font.name}'`,
      label: font.name,
    })),
  },
  {
    label: i18next.t('text.classic', { ns: ['common'] }),
    options: classicFonts.map((font) => ({
      value: `'${font.name}'`,
      label: font.name,
    })),
  },
  {
    label: i18next.t('text.calligraphy', { ns: ['common'] }),
    options: calligraphicFonts.map((font) => ({
      value: `'${font.name}'`,
      label: font.name,
    })),
  },
  {
    label: i18next.t('text.handwritten', { ns: ['common'] }),
    options: handwrittenFonts.map((font) => ({
      value: `'${font.name}'`,
      label: font.name,
    })),
  },
  {
    label: i18next.t('text.fancy', { ns: ['common'] }),
    options: fantasyFonts.map((font) => ({
      value: `'${font.name}'`,
      label: font.name,
    })),
  },
];
